import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Regist from '../views/Regist.vue'

import Home from '../views/Home.vue'
import Main from '../views/Main.vue'

import RouteInput from '../views/route/RouteInput.vue'
import RouteManage from '../views/route/RouteManage.vue'

import OrderInput from '../views/order/OrderInput.vue'
import OrderManage from '../views/order/OrderManage.vue'

import TicketInput from '../views/ticket/TicketInput.vue'
import TicketManage from '../views/ticket/TicketManage.vue'
import TicketHistory from '../views/ticket/TicketHistory.vue'

import VehicleManage from '../views/VehicleManage.vue'
import DriverManage from '../views/DriverManage.vue'
import GuideManage from '../views/GuideManage.vue'
import PointManage from '../views/PointManage.vue'
import StoreManage from '../views/StoreManage.vue'

import Sys from '../views/sys/Sys.vue'
import MenuManage from '../views/sys/MenuManage.vue'
import AccountManage from '../views/sys/AccountManage.vue'
import RoleManage from '../views/sys/RoleManage.vue'

import VisitorManage from '../views/store/visitor/VisitorManage.vue'

//清楚导航错误提示
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [{
    path: '/login',
    name: '登录',
    component: Login,
},
{
    path: '/error/404',
    name: 'error-404',
    component: () =>
        import('@/views/error/404.vue')
},
{
    path: '/regist',
    name: '注册',
    component: Regist,
},
{
    path: '/',
    component: Main,
    children: [{
        path: '',
        name: '首页',
        component: Home,
    },

    {
        path: '/route-input',
        name: '线路录入',
        component: RouteInput
    },
    {
        path: 'route-manage',
        name: '线路管理',
        component: RouteManage,
    },
    {
        path: 'order-input',
        name: '订单录入',
        component: OrderInput,
    },
    {
        path: 'order-manage',
        name: '订单管理',
        component: OrderManage,
    },
    {
        path: 'ticket-input',
        name: '行程单录入',
        component: TicketInput,
    },
    {
        path: 'ticket-history',
        name: '历史行程',
        component: TicketHistory,
    },
    {
        path: 'ticket-manage',
        name: '行程单管理',
        component: TicketManage,
    },

    {
        path: 'vehicle',
        name: '车辆管理',
        component: VehicleManage,
    },
    {
        path: 'driver',
        name: '司机管理',
        component: DriverManage,
    },
    {
        path: 'guide',
        name: '导游管理',
        component: GuideManage,
    },
    {
        path: 'point',
        name: '景区/景点',
        component: PointManage,
    },
    {
        path: 'store',
        name: '门店管理',
        component: StoreManage,
    },
    {
        path: 'sys',
        name: '系统设置',
        component: Sys,
        children: [{
            path: 'account',
            name: '账户管理',
            component: AccountManage,
        },
        {
            path: 'role',
            name: '角色管理',
            component: RoleManage,
        },
        {
            path: 'menu',
            name: '菜单管理',
            component: MenuManage,
        },
        ]
    },


    ]
},
{
    path: '/store',
    name: "门店界面",
    component: Main,
    children: [{
        path: 'route',
        name: '创建行程',
        component: OrderInput,
    },
    {
        path: 'visitor-manage',
        name: '游客管理',
        component: VisitorManage,
    },
    ]
}
]

const router = new VueRouter({
    // mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router